import {
  createValidation,
  validatorRequired,
  validatorEmail,
} from '../../utils/formValidators';
import { gridOperator } from '../../constants/parameters';

export default createValidation([
  {
    name: gridOperator.NAME,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: gridOperator.EMAIL,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorEmail()(field),
    ],
  },
  {
    name: gridOperator.CODE,
    validators: (field) => validatorRequired()(field),
  },
]);
